module.exports = __webpack_public_path__ + "img/senderrand-business-step-1.3af1bf91.svg";